<template>
	<div class="position-relative">
		<div class="pv-asmntcard mobmt0">
			<div class="fs-14 fw-M fam-mont color-f1f1f1">
				<img
					src="../../assets/newdesign/myprofile/profilevisibility/asmnticon.svg"
					alt=""
					class="mr-1"
				/>
				Assessments
			</div>
			<div
				class="fw-B fs-16 fam-mont text-white mt-3"
				:class="{
					'my-3': $route.name == 'Leaderboard',
				}"
			>
				{{
					$route.name == "Leaderboard"
						? `Selected ${selectedCategoryText} Assessments for this week’s leaderboard`
						: "Get better chances of getting hired by completing the best assessments for you!"
				}}
			</div>

			<section
				class="mob-overflow-x"
				ref="scrollContainer"
				@touchstart="onTouchStart"
				@touchend="onTouchEnd"
			>
				<template v-if="loading">
					<AssessmentCardSkeleton
						v-for="i in $route.name === 'Leaderboard' ? 4 : 2"
						:key="i + 'shimmer'"
						class="mt-3"
						customClass="assesspro-cards w-100"
					/>
				</template>
				<template v-else>
					<AssessmentCard
						v-for="(assessment, index) in assessments"
						:key="index"
						:assessment="assessment"
						fromJobSearch="main"
						:fromAsmnttestcard="true"
						class="mt-3"
						v-if="!isMobile || sliderIndex === index"
					/>
				</template>
				<!-- Slider dots -->
				<div class="slider-dots-container mb-4" id="hideinlaptop">
					<div class="slider-dots d-flex justify-content-center">
						<span
							v-for="(dot, index) in assessments"
							:key="'dot-' + index"
							class="dot"
							:class="{ active: sliderIndex === index }"
							@click="setSlide(index)"
						></span>
					</div>
				</div>
			</section>
			<b-button
				class="viewall-asmnt-btn-mobile pvcheckbtn candash-cancelBtn pointer mt-3"
				@click="viewAllAssessment()"
			>
				View All Assessments
			</b-button>
			<TestDetailsAP
				v-if="showTestDetails"
				:showTestDetails="showTestDetails"
				:selectedAssessment="selectedAssessment"
				:public="true"
				@closeTestModal="showTestDetails = false"
				@purchase-success="handlePurchaseSuccess"
				ref="testDetails"
			/>
			<div style="display: none" ref="responseContainer"></div>
		</div>
	</div>
</template>

<script>
import { getPublicAssessments } from "@/utils/apiFunctions";
import TestDetailsAP from "@/views/AssessmentProgress/TestDetailsAP.vue";
import { mapGetters } from "vuex";
import payment from "@/components/mixin/payment";
import AssessmentCard from "@/components/Assessment/AssessmentCard.vue";
import AssessmentCardSkeleton from "@/components/Assessment/AssessmentCardSkeleton.vue";

export default {
	name: "AsmntTestcards",
	data() {
		return {
			assessments: {},
			showTestDetails: false,
			selectedAssessment: {},
			loading: true,
			sliderIndex: 0,
			sliderTimer: null,
			isMobile: false,
			touchStartX: 0,
			touchEndX: 0,
		};
	},
	props: {
		selectedCategory: {
			type: String,
			default: "technical",
		},
	},
	mixins: [payment],
	components: {
		TestDetailsAP,
		AssessmentCard,
		AssessmentCardSkeleton,
	},
	computed: {
		selectedCategoryText() {
			// fallback mapping
			const map = {
				technical: "Technical",
				nontechnical: "Non-Technical",
				communication: "Communication",
			};

			return map[this.selectedCategory] || "";
		},

		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreen);
	},
	mounted() {
		this.checkScreen();

		window.addEventListener("resize", this.checkScreen);
	},

	watch: {
		selectedCategory: {
			immediate: true, // runs on load also
			handler(newVal) {
				if (!newVal) return;

				this.loading = true;

				this.sliderIndex = 0; // reset slider
				this.stopSlider();

				this.getAllAssessments(); //  API call
			},
		},
	},
	methods: {
		handlePurchaseSuccess() {
			this.assessment.purchased = true;
		},
		onTouchStart(e) {
			this.touchStartX = e.changedTouches[0].clientX;
		},

		onTouchEnd(e) {
			this.touchEndX = e.changedTouches[0].clientX;
			this.handleSwipe();
		},

		handleSwipe() {
			const diff = this.touchStartX - this.touchEndX;

			// threshold to avoid accidental touch
			if (Math.abs(diff) < 50) return;

			if (diff > 0) {
				// swipe left → next
				this.nextSlide();
			} else {
				// swipe right → prev
				this.prevSlide();
			}
		},

		prevSlide() {
			this.sliderIndex =
				(this.sliderIndex - 1 + this.assessments.length) %
				this.assessments.length;
		},
		checkScreen() {
			this.isMobile = window.innerWidth <= 1028;
		},
		startSlider() {
			this.sliderTimer = setInterval(() => {
				this.nextSlide();
			}, 5000);
		},
		stopSlider() {
			if (this.sliderTimer) {
				clearInterval(this.sliderTimer);
			}
		},
		nextSlide() {
			this.sliderIndex = (this.sliderIndex + 1) % this.assessments.length;
		},
		setSlide(index) {
			this.sliderIndex = index;
			this.stopSlider();
			this.startSlider();
		},

		viewAllAssessment() {
			const query = {};

			if (this.$route.name === "Leaderboard") {
				query.practice = "leaderboard";
				query.from = "Leaderboard";
				query.type = "assessment";
			}
			if (this.$route.name === "ProfileVisibility") {
				query.from = "profilevisibility";
			}
			console.log("query", query);

			this.$router.push({
				name: "CandidateAssessmentProgress",
				query,
			});
		},
		goToAssessment(assessment) {
			this.selectedAssessment = assessment;
			this.showTestDetails = true;
			this.public = assessment.isPublic;
		},
		async getAllAssessments() {
			const payload = {
				page: 0,
				count: 2,
				email: this.userInfo.email,
				searchQuery: "",
			};
			if (this.$route.name == "Leaderboard") {
				payload.filter = {
					assessmentType: ["leaderboard"],
					leaderboardCategory: this.selectedCategory,
				};

				payload.count = 4;
			}
			console.log("the payload", payload);
			const res = await getPublicAssessments(payload);
			console.log("the res", res);
			if (res.status == 200) {
				this.assessments = res.data.data.data;
				if (window.innerWidth <= 1028) {
					this.startSlider();
				}
			}
			this.loading = false;
		},
	},
};
</script>

<style>
.pv-asmntcard {
	background: url("../../assets/newdesign/myprofile/profilevisibility/asmntbg.png");
	background-repeat: no-repeat;
	box-shadow: 0px 14.84px 32.1533px rgba(74, 58, 255, 0.07);
	border-radius: 8px;
	padding: 15px;
	background-size: cover;
}

.color-f1f1f1 {
	color: #f1f1f1;
}
.pvcheckbtn {
	background-color: white !important;
}
.color-E0E0E0 {
	color: #e0e0e0;
}
/* .asmnttest-cards {
	background: rgba(216, 233, 247, 0.8);
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	backdrop-filter: blur(5px);
	border-radius: 5px;
	padding: 9px;
} */
.color-0D47A1 {
	color: #0d47a1;
}
.white-ver-line {
	width: 15px;
	height: 0.04px;
	opacity: 0.9;
	border: 1px solid #d9d9d9;
	transform: rotate(-90deg);
}
@media only screen and (max-width: 1028px) {
	.asmnttest-cards {
		flex-shrink: 0;
		width: 100%;
	}
	.mob-overflow-x {
		display: flex;
		position: relative;
	}

	.slider-dots-container {
		z-index: 10;
		padding-bottom: 25px;
		position: absolute;
		width: 100%;
		bottom: -75px;
	}
	.pv-asmntcard {
		height: 352px;
		/* margin-bottom: 45px; */
		width: 100%;
		border-radius: 8px 8px 0 0 !important;
		padding: 10px !important;
	}
	.dot {
		width: 8px;
		height: 8px;
		background: rgba(217, 217, 217, 0.5);
		border-radius: 50%;
		margin: 0 4px;
		cursor: pointer;
		transition: all 0.3s ease;
	}
	.pvcheckbtn {
		padding: 8px 20px !important;
		background: #ffffff;
		border-radius: 25px !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border: none !important;
	}
	.dot.active {
		background-color: #fff;
		width: 10px;
		height: 10px;
	}
	.viewall-asmnt-btn-mobile {
		position: absolute;
		bottom: -35px;
		width: 100%;
		left: 0;
		border-radius: 0 0 12px 12px !important;
	}
}
</style>
